// extracted by mini-css-extract-plugin
export default {"Main":"YAz35","Main_hidden":"FO4Cd","Main_displayed":"RTSI4"};